import styled from "styled-components";

export const LandingPageContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
`;
